import { Popup } from '../../../../ui/popup/popup';

interface ICVVInfoPopup {
    onClose: () => void;
}

const CVVInfoPopup = ({ onClose } : ICVVInfoPopup) => {

    return (
        <Popup width="400px" height="270px" close={ onClose }>
            <div className="flex flex-col justify-center items-center w-full h-full my-4 text-center">

                <p className="mb-2 text-xl">CVV - Security Number</p>
                <p className="mb-4">The 3-digit number is printed on the back of your card. For American Express, it's the 4-digit number on the front.</p>

                <button
                    type="button"
                    className="w-btn"
                    onClick={ onClose }
                    style={{ width: '170px' }}>OK</button>
            </div>
        </Popup>
    )
};

export default CVVInfoPopup;